import { DataRequirements, } from "../data.requirements";
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class CheckPlanUseCase {
    constructor(data) {
        this.data = data;
    }
    run() {
        return this.data.checkPlan();
    }
}
CheckPlanUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckPlanUseCase_Factory() { return new CheckPlanUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: CheckPlanUseCase, providedIn: "root" });
